export default {
  SET_EMPLOYEES(state, employes) {
    state.employees = employes;
  },
};
